"use client";

/**
 * StatusBar — the persistent bottom bar of the terminal OS shell.
 *
 * A quiet, OS-style strip: it reflects the active terminal tab and open-tab
 * count, and surfaces the primary shortcuts. Reading the tab store here keeps
 * the chrome and the workspace surface in sync without prop drilling.
 */

import { formatHotkey, HOTKEYS } from "../../lib/hotkeys";
import { useTerminalTabs } from "../terminal/tabs-store";

export function StatusBar() {
  const { tabs, activeId } = useTerminalTabs();
  const active = tabs.find((tab) => tab.id === activeId) ?? null;
  const commandHint = formatHotkey(HOTKEYS.openCommandMenu);
  const newTabHint = formatHotkey(HOTKEYS.newTab);

  return (
    <footer className="flex h-6 shrink-0 items-center justify-between gap-4 border-t bg-background px-3 text-[11px] text-muted-foreground">
      <div className="flex min-w-0 items-center gap-3">
        <span className="inline-flex shrink-0 items-center gap-1.5">
          <span
            aria-hidden
            className="size-1.5 rounded-full bg-emerald-500"
            title="Connected"
          />
          Ready
        </span>
        {active ? (
          <span className="truncate">
            <span className="text-foreground">{active.title}</span>
            {active.kind ? (
              <span className="ml-1.5 opacity-70">{active.kind}</span>
            ) : null}
          </span>
        ) : (
          <span className="opacity-70">No tabs</span>
        )}
      </div>
      <div className="flex shrink-0 items-center gap-3">
        <span className="hidden md:inline">{commandHint} commands</span>
        <span className="hidden sm:inline">{newTabHint} new tab</span>
        <span>
          {tabs.length} {tabs.length === 1 ? "tab" : "tabs"}
        </span>
      </div>
    </footer>
  );
}
